import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-us-div about-section">
      <div className="about-us-heading">
        <h3 className="about-us-title">About Us</h3>
      </div>
      <div className="about-us-content">
        <p>
          R.A. Engineering & Services (RAES) is a registered engineering firm
          established in 2018, delivering reliable engineering solutions for
          healthcare, manufacturing, and commercial facilities. We specialize in
          ventilation, air-conditioning, and fire-protection system design,
          ensuring full compliance with industry codes and safety standards. Our
          services also include steel and metal fabrication, supported by an
          in-house facility with precision machinery and skilled craftsmen.
          Backed by a multidisciplinary team of engineers and architects, RAES
          manages small to medium-scale projects from design to successful
          turnover—ensuring quality, efficiency, and client satisfaction.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
